/**
 * "Buy with Cash On Delivery" — AYSOMART
 * Adds the selected product/variant to the cart, then goes straight to
 * checkout (where Cash on Delivery is a payment option). Delegated click
 * handler so it also works for AJAX-rendered forms (quick-add, etc.).
 */
(function () {
  if (window.__aysoCodBound) return;
  window.__aysoCodBound = true;

  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-cod-checkout]');
    if (!btn || btn.hasAttribute('disabled')) return;
    event.preventDefault();

    const form =
      btn.closest('form') ||
      btn.closest('product-form-component')?.querySelector('form') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!form) return;

    btn.setAttribute('disabled', '');
    btn.classList.add('is-loading');

    const addUrl =
      (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';

    try {
      const res = await fetch(addUrl, {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: new FormData(form),
      });
      if (!res.ok) throw new Error('add-to-cart failed');
      window.location.href = '/checkout';
    } catch (err) {
      btn.removeAttribute('disabled');
      btn.classList.remove('is-loading');
    }
  });
})();
